export default "__VITE_ASSET__DHseeXmr__"